// extracted by mini-css-extract-plugin
export var deliveryRow = "_ox-a";
export var fixedHeight = "_ox-4";
export var freightLogo = "_ox-9";
export var fullWidth = "_ox-3";
export var priceColumn = "_ox-5";
export var radioSelected = "_ox-7";
export var radioUnselected = "_ox-6";
export var selectedOption = "_ox-2";
export var selectedOptionContainer = "_ox-1";
export var selection = "_ox-0";
export var tallSkeletonText = "_ox-8";